import { EmailIcon, PortsIcon, ScheduleIcon, VesselsIcon } from './Icons';

function MetricIcon({ name }) {
  const icons = {
    mail: <EmailIcon />,
    ship: <VesselsIcon />,
    anchor: <PortsIcon />,
    calendar: <ScheduleIcon />,
  };

  return <span className="metric-card__icon">{icons[name]}</span>;
}

function MetricCard({ title, value, subtext, icon, highlight = false }) {
  return (
    <article className={`metric-card ${highlight ? 'metric-card--highlight' : ''}`}>
      <div className="metric-card__header">
        <h3>{title}</h3>
        {icon ? <MetricIcon name={icon} /> : null}
      </div>
      <p className="metric-card__value">{value}</p>
      <p className="metric-card__subtext">{subtext}</p>
    </article>
  );
}

export default MetricCard;
